// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__30PoT","info":"Note_info__39w8l","note":"Note_note__3DONH","actions":"Note_actions__2AAqu"};